import React, { useMemo, useState } from 'react'
import { Controller } from 'react-hook-form'
import { LayoutColumn, LayoutWrapper, Label } from '../..'
import { TIME_SLOTS, FORMATTED_TIMEZONES } from '@/utilities'
import { DropDownSelect } from '../../../../fields/DropDownSelect'
import { DropdownSearch } from '../../DropdownSearch'

export const DeliveryDropdown = ({ field, options, showSearch }) => {
  const { onChange, value, ref, name } = field
  const [inputValue, setInputValue] = useState('')

  const filterItemsByInputValue = useMemo(() => {
    if (!options) return []
    return options.filter(item => item.label.toLowerCase().includes(inputValue.toLowerCase()))
  }, [inputValue, options])

  const menuSearch = showSearch && <DropdownSearch inputValue={inputValue} setInputValue={setInputValue} />

  return (
    <DropDownSelect
      onChange={onChange}
      options={filterItemsByInputValue}
      value={value}
      ref={ref}
      name={name}
      menuSearch={menuSearch}
    />
  )
}

export const Delivery = ({ control }) => {
  return (
    <LayoutWrapper flex="1">
      <LayoutColumn gap="spaceGapSmall">
        <Label htmlFor="deliveryTime">
          Delivery Time
        </Label>
        <Controller
          control={control}
          name="deliveryTime"
          render={control => <DeliveryDropdown field={control.field} options={TIME_SLOTS} />}
        />
      </LayoutColumn>
      <LayoutColumn gap="spaceGapSmall" flex="1">
        <Label htmlFor="timeZone">
          Timezone
        </Label>
        <Controller
          control={control}
          name="timeZone"
          render={control => <DeliveryDropdown field={control.field} options={FORMATTED_TIMEZONES} showSearch={true} />}
        />
      </LayoutColumn>
    </LayoutWrapper>
  )
}
